(function (w) {
    let isInitialBlockPhase = true;
    let pageFullyLoaded = false;
    let userScrolled = false;
    let hasReleased = false;
    let queuedSrcMap = {};
    let queuedSrcList = [];

    function getUrlId(url) {
        let match = String(url || '').match(/[?&]id=([^&]+)/i);
        return match ? decodeURIComponent(match[1]).trim() : '';
    }

    function shouldBlock(url) {
        if (!isInitialBlockPhase) return false;

        let src = String(url || '');
        if (!src) return false;

        if (src.indexOf('replocdn.com') !== -1) {
            return true;
        }

        if (src.indexOf('www.googletagmanager.com') !== -1) {
            return true;
        }

        if (src.indexOf('rebuyengine.com') !== -1) {
            return true;
        }

        if (src.indexOf('cdn.rebuyengine.com') !== -1) {
            return true;
        }

        if (src.indexOf('connect.facebook.net') !== -1) {
            return true;
        }

        if (src.indexOf('static.klaviyo.com') !== -1) {
            return true;
        }

        if (src.indexOf('cdn.shopify.com/shopifycloud/preview-bar/') !== -1) {
            return true;
        }

        if (src.indexOf('static-tracking.klaviyo.com') !== -1) {
            return true;
        }

        // Okendo reviews widget — its loader pulls a 30+ request cascade. The reviews live
        // below the fold, so defer it until the first interaction like the other third parties.
        if (src.indexOf('okendo.io') !== -1) {
            return true;
        }

        if (src.indexOf('cdn.shopify.com') !== -1) {
            return true;
        }

        return false;
    }

    function queueSrc(src) {
        let normalized = String(src || '');
        if (!normalized || queuedSrcMap[normalized]) return;
        queuedSrcMap[normalized] = true;
        queuedSrcList.push(normalized);
    }

    function tryReleaseBlockedScripts() {
        if (hasReleased || !pageFullyLoaded || !userScrolled) return;
        hasReleased = true;
        isInitialBlockPhase = false;

        document.querySelectorAll('script[data-blocked-src]').forEach(function (script) {
            queueSrc(script.getAttribute('data-blocked-src'));
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        });

        let prioritizedSrcList = queuedSrcList.slice().sort(function (a, b) {
            let aIsAlia = a.indexOf('backend.alia-prod.com/public/') !== -1;
            let bIsAlia = b.indexOf('backend.alia-prod.com/public/') !== -1;
            if (aIsAlia === bIsAlia) return 0;
            return aIsAlia ? -1 : 1;
        });

        prioritizedSrcList.forEach(function (src) {
            let s = document.createElement('script');
            s.async = true;
            s.src = src;
            if (src.indexOf('backend.alia-prod.com/public/') !== -1) {
                s.addEventListener('load', function () {
                    w.setTimeout(function () {
                        w.dispatchEvent(new Event('scroll'));
                    }, 120);
                }, { once: true });
            }
            document.head.appendChild(s);
        });
    }

    function markBlocked(script, src) {
        if (!script) return;
        try {
            queueSrc(src || script.getAttribute('src') || script.src);
            script.type = 'javascript/blocked';
            script.setAttribute('data-blocked-src', src || '');
            script.removeAttribute('src');
        } catch (e) { }
    }

    if (w.HTMLScriptElement) {
        let originalSetAttribute = w.HTMLScriptElement.prototype.setAttribute;
        w.HTMLScriptElement.prototype.setAttribute = function (name, value) {
            if (String(name).toLowerCase() === 'src' && shouldBlock(value)) {
                markBlocked(this, value);
                return;
            }
            return originalSetAttribute.apply(this, arguments);
        };

        let srcDescriptor = Object.getOwnPropertyDescriptor(w.HTMLScriptElement.prototype, 'src');
        if (srcDescriptor && srcDescriptor.set && srcDescriptor.get) {
            Object.defineProperty(w.HTMLScriptElement.prototype, 'src', {
                configurable: true,
                enumerable: srcDescriptor.enumerable,
                get: function () {
                    return srcDescriptor.get.call(this);
                },
                set: function (value) {
                    if (shouldBlock(value)) {
                        markBlocked(this, value);
                        return;
                    }
                    srcDescriptor.set.call(this, value);
                }
            });
        }
    }

    let originalAppendChild = Node.prototype.appendChild;
    Node.prototype.appendChild = function (node) {
        if (node && node.tagName === 'SCRIPT') {
            let src = node.getAttribute('src') || node.src;
            if (shouldBlock(src)) {
                markBlocked(node, src);
                return node;
            }
        }
        return originalAppendChild.call(this, node);
    };

    let originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function (node, referenceNode) {
        if (node && node.tagName === 'SCRIPT') {
            let src = node.getAttribute('src') || node.src;
            if (shouldBlock(src)) {
                markBlocked(node, src);
                return node;
            }
        }
        return originalInsertBefore.call(this, node, referenceNode);
    };

    function scanAndRemoveBlocked() {
        let scripts = document.querySelectorAll('script[src]');
        scripts.forEach(function (script) {
            let src = script.getAttribute('src') || script.src;
            if (shouldBlock(src)) {
                markBlocked(script, src);
                if (script.parentNode) {
                    script.parentNode.removeChild(script);
                }
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scanAndRemoveBlocked, { once: true });
    } else {
        scanAndRemoveBlocked();
    }

    let observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (!node || node.nodeType !== 1) return;
                if (node.tagName === 'SCRIPT') {
                    let src = node.getAttribute('src') || node.src;
                    if (shouldBlock(src)) {
                        markBlocked(node, src);
                        if (node.parentNode) node.parentNode.removeChild(node);
                    }
                    return;
                }
                if (node.querySelectorAll) {
                    node.querySelectorAll('script[src]').forEach(function (script) {
                        let nestedSrc = script.getAttribute('src') || script.src;
                        if (shouldBlock(nestedSrc)) {
                            markBlocked(script, nestedSrc);
                            if (script.parentNode) script.parentNode.removeChild(script);
                        }
                    });
                }
            });
        });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });

    function onRealScroll(event) {
        if (event && event.isTrusted === false) return;
        pageFullyLoaded = true;
        userScrolled = true;
        tryReleaseBlockedScripts();
    }

    w.addEventListener('scroll', onRealScroll, { passive: true, once: true });
    w.addEventListener('wheel', onRealScroll, { passive: true, once: true });
    w.addEventListener('touchmove', onRealScroll, { passive: true, once: true });
    w.addEventListener('mousemove', onRealScroll, { passive: true, once: true });
})(window);
